"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentTemplate = void 0;
class CommentTemplate {
    static resolve(f) {
        return f.description ? `# ${f.description}` : '';
    }
}
exports.CommentTemplate = CommentTemplate;
